<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Mps2ap/tc-custom/9781642793123.jpg?1726574202299" alt="This image is the cover for the book Secret Lies Within"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Secret Lies Within
      </h1>
      <p class="bookDescription body article font2">
        <b><i>The Secret Lies Within</i> in an inside-out look at the trauma and pain so many people experience in this lifetime and how breaking the silence is the first step to freedom.</b><p> Many people experience trauma or pain and keep it to themselves, letting it become a secret that holds them captive. They live with pain, blame, and shame, unsure of what to do or how to break free. The secrets grow, causing people to become increasingly silent while they hope and pray for better days, struggling to believe they will ever come.</p><p><i>The Secret Lies Within</i> is an honest, vulnerable, and courageous narrative about nearly losing everything, breaking the silence of secrets, and finding purpose in pain. Auntie Anne Beiler, founder of the international franchise Auntie Anne’s pretzels, shares her journey through the loss of a child, sexual abuse, and the resulting trauma that haunted her for years, reminding readers they are not alone in their pain. Anne weaves brief stories of other brave individuals throughout her own and presents a picture of hope for those who have experienced trauma. Those with deep secrets of their own are encouraged to break their silence and are shown the power to overcome through confession and reach a whole new level of freedom.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anne Beiler, Emily Sutherland
      </h2>
      
      <p class="authorDescription body article">Anne Beiler is best known as the founder of Auntie Anne’s pretzels, the world’s largest pretzel franchise. Her entrepreneurial insights and personal story have been featured on many television shows including Secret Millionaire, The Oprah Winfrey Show, Good Morning America, and ANDERSON. Her story has been highlighted in numerous publications including Fortune Magazine, Inc Magazine, Guidepost, and Entrepreneur Magazine. Anne is the author of the business memoir, Twist of Faith, and Children’s Book, Auntie Anne: My Story. Anne spent most of her life in Lancaster, Pennsylvania and currently resides in Salado, Texas.Emily Sutherland is an internationally recognized storyteller whose body of work spans a broad spectrum of genres and mediums, ranging from television and radio, to books and magazines, to podcasts and the blogosphere. With more than twenty years of professional experience in the music industry, her name appears in the credits of dozens of Billboard chart-topping volumes produced by Gaither Television Productions, which air on television networks around the world. She is the author of children’s book It’s Hard To Hug a Porcupine. Emily and her husband, Scott, are cofounders of the Love Better movement (www.lovebetter.world) and hosts of The Love Better Podcasts. Emily resides in Fishers, Indiana.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?285a9840